import React from "react";
import LoadingMessage from "./LoadingMessage/LoadingMessage";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CallbackComponent } from "../../../Utils/Oidc/oidcRedux";
import userManager from "../../../Utils/Oidc/userManager";
import { useHistory } from "react-router-dom";
import * as loggedInUserIdActions from "../../../store/actions/loggedInUserIdActions";
import PropTypes from "prop-types";
//TODO:For the future use Case
// import RedirectingMessage from "../RedirectingMessage/RedirectingMessage";
import "../RedirectingMessage/RedirectingMessage.css";
import { flushBreadCrumps } from "../../Factory/Molecules/Common/PageHeaders/TemplatePageTitle/M_BreadCrumbs.helper";
import {
  getRecordByProperty,
  validSubdomainUser,
  getColourScheme,
  getDefaultRedirectURLForUser,
  getGlobalSearchPermission,
} from "./apiService";
import { setShowSeach } from "../../../store/actions/globalSearchAction";
import { fetchUserRolesRequest } from "../../../store/actions/userRoles.actions";
import {
  getAllUsers,
  getUserImages,
} from "./apiService";
import * as userActions from "../../../store/actions/userActions";


const CallbackPage = (props) => {
  const history = useHistory();
  React.useEffect(() => {
    flushBreadCrumps();
  });

  const getTheme = async (user) => {
    // Dispatch LoggedIn User Data
    await props.getLoggedInUser();
    props.fetchUserRolesRequest();

    // Dispatch Show Search
    const searchShowRes = await getGlobalSearchPermission(user);
    if (!searchShowRes.message) {
      props.setShowSeach(searchShowRes);
    } else {
      props.setShowSeach(false);
    }
    let email =
      props.state &&
      props.state.oidc &&
      props.state.oidc.user &&
      props.state.oidc.user.profile &&
      props.state.oidc.user.profile.email;

    if (email) {
      let apiPayload = {
        label: "contact",
        properties: {
          email: email,
        },
      };
      // Calling getRecordByProperty API
      getRecordByProperty(apiPayload, email);
    }
    await getColourScheme();

    localStorage.removeItem("manageMenus");
    // Calling Valid validsubdomainuser API
    const validSubdomainUserResponse = await validSubdomainUser();

    //user validation for subdomain
    let redirectUrl = null;
    if (validSubdomainUserResponse) {
      if (user.state?.pathname) {
        redirectUrl = user.state.pathname;
      } else {
        //user validation for get user landing url
        redirectUrl = await getDefaultRedirectURLForUser();
      }
    } else {
      redirectUrl = "/securelogout";
    }

    history.push(redirectUrl ? redirectUrl : "/dashboard");
    localStorage.setItem(
      "UserDefaultURL",
      redirectUrl ? redirectUrl : "/dashboard"
    );
    fetchAndBindUsers();
  };

  const fetchAndBindUsers = async () => {
    try {
      const usersRes = await getAllUsers();
      if (usersRes && usersRes.Contacts) {
        const users = usersRes.Contacts;
        const emails = users
          .map((u) => u.Email || u.email || u.EmailAddress)
          .filter((e) => e);

        if (emails.length > 0) {
          const profileImageKeys = emails.map((email) => `profile_${email}`);
          const imagesRes = await getUserImages(profileImageKeys);
          const images =
            imagesRes && imagesRes.image ? imagesRes.image : [];

          const combinedUsers = users.map((user) => {
            const email = user.Email || user.email || user.EmailAddress;
            const userImage = images.find(
              (img) => img.file === `profile_${email}`
            );
            return {
              ...user,
              email: email, // ensure consistent email key
              image: userImage ? userImage.link : null,
            };
          });
          props.setAllUsers(combinedUsers);
        } else {
          props.setAllUsers(users);
        }
      }
    } catch (error) {
      console.error("Error fetching users or images:", error);
    }
  };

  const successCallback = (user) => {
    getTheme(user);
  };

  const errorCallback = () => {
    history.push("/");
  };

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={successCallback}
      errorCallback={errorCallback}
    >
      <div>
        <LoadingMessage />
      </div>
    </CallbackComponent>
  );
};
function mapStateToProps(state) {
  return { state, loggedIn: state.getLoggedInUserReducer };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...loggedInUserIdActions,
      ...userActions,
      setShowSeach,
      fetchUserRolesRequest,
    },
    dispatch
  );
}
CallbackPage.propTypes = {
  getLoggedInUser: PropTypes.func,
  loggedinUser: PropTypes.func,
  loggedIn: PropTypes.array,
  currentPageId: PropTypes.string,
  content: PropTypes.any,
  state: PropTypes.any,
  setShowSeach: PropTypes.func,
  fetchUserRolesRequest: PropTypes.func,
  setAllUsers: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps)(CallbackPage);
